import React, { useRef } from 'react';
import { GlobalHeader, GlobalFooter } from '@/components/Layouts';
import { useConfigProvider } from '@/context/ConfigProvider';
import classNames from 'classnames';
import { AppSettings } from '@/shared/app-common';
import { useTranslation } from 'next-i18next';
import { EventName } from '@/shared/event-types';

interface LayoutProps {
  head?: React.ReactNode;
  children: React.ReactNode;
  showHeader?: boolean;
  showFooter?: boolean;
}

const Layout = ({ children, head }: LayoutProps) => {
  const { isMobile } = useConfigProvider();
  const { t } = useTranslation('common');
  const ref = useRef(null);

  const getNavItems = () => {
    switch (AppSettings.type) {
      case '16':
        return [
          {
            text: t('Solution'),
            path: `/onlyfans-protection`,
            gaName: EventName.header_service,
            dropdownItems: [
              {
                text: t('OnlyFans Content Protection'),
                path: `/onlyfans-protection`,
                gaName: EventName.header_onlyfans_protection,
              },
              {
                text: t('Impersonation Account Removal'),
                path: `/remove-fake-account`,
                gaName: EventName.header_remove_fake_account,
              },
              {
                text: t('Cam Model Protection'),
                path: `/cam-model-protection`,
                gaName: EventName.header_cam_model_protection,
              },
              {
                text: t('Remove Leaked Onlyfans Content'),
                path: `/remove-leaked-onlyfans-content`,
                gaName: EventName.header_remove_leaked_onlyfans_content,
              },
            ],
          },
          {
            text: t('Service'),
            path: `/content-monitoring`,
            gaName: EventName.header_service,
            dropdownItems: [
              {
                text: t('Content Monitoring'),
                path: `/content-monitoring`,
                gaName: EventName.header_onlyfans_protection,
              },
              {
                text: t('DMCA Takedown'),
                path: `/dmca-takedown`,
                gaName: EventName.header_remove_fake_account,
              },
              {
                text: t('Shadowban Test'),
                path: `/shadowban-test`,
                gaName: EventName.header_shadowban_test,
              },
            ],
          },
          {
            text: t('Pricing'),
            path: '/plan',
            gaName: EventName.view_pricing,
          },
          {
            text: t('Resources'),
            path: `/dmca-protection-badge`,
            gaName: EventName.header_tool,
            dropdownItems: [
              {
                text: t('Blog'),
                path: `/blog`,
                gaName: EventName.header_tool,
              },
              {
                text: t('DMCA Badges'),
                path: `/dmca-protection-badge`,
                gaName: EventName.header_tool,
              },
              {
                text: t('Guides'),
                path: `/dmca-protection-badge`,
                gaName: EventName.header_tool,
              },
              {
                text: t('OnlyFans Restricted Words Checker'),
                path: `/onlyfans-restricted-words-checker`,
                gaName: EventName.header_tool,
              },
              {
                text: t('OnlyFans Caption Generator'),
                path: `/onlyfans-caption-generator`,
                gaName: EventName.header_tool,
              },
              {
                text: t('Platform Comparison'),
                path: `/compare`,
                gaName: EventName.header_tool,
              },
              // {
              //   text: t('OnlyFans Search'),
              //   path: `/onlyfans-search`,
              //   gaName: EventName.header_tool,
              // },
            ],
          },
          // {
          //   text: t('Affiliate Program'),
          //   path: `/affiliate`,
          //   gaName: EventName.header_affiliate,
          // },
        ];

      default:
        [{}];
    }
  };

  return (
    <div className={'layout'}>
      {head}
      <header className={'header'}>
        <GlobalHeader isMobile={isMobile} navItems={[...getNavItems()]} />
      </header>
      <main
        ref={ref}
        style={{
          marginTop: 'calc(var(--pietra-global-header-heigth))',
        }}
        className={classNames('main', {
          mobile: isMobile,
        })}
      >
        <div>{children}</div>
      </main>
      <footer className={'footer'}>
        <GlobalFooter />
      </footer>
    </div>
  );
};
export default Layout;
